"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
/**
 * Created by Hayk.Andriasyan on 4/19/2018.
 */
var TextStyleConverter = /** @class */ (function () {
    function TextStyleConverter() {
    }
    TextStyleConverter.convertStringToFontName = function (fontname) {
        if (fontname === undefined || fontname === null) {
            return null;
        }
        switch (fontname) {
            case 'ARIAL':
                return idm_report_export_service_client_js_1.FontName.ARIAL;
            case 'ARIAL_BLACK':
                return idm_report_export_service_client_js_1.FontName.ARIAL_BLACK;
            case 'VERDANA':
                return idm_report_export_service_client_js_1.FontName.VERDANA;
            case 'TIMES_NEW_ROMAN':
                return idm_report_export_service_client_js_1.FontName.TIMES_NEW_ROMAN;
            case 'COURIER':
                return idm_report_export_service_client_js_1.FontName.COURIER;
            case 'LUCIDA_CONSOLE':
                return idm_report_export_service_client_js_1.FontName.LUCIDA_CONSOLE;
            case 'ROBOTO':
                return idm_report_export_service_client_js_1.FontName.ROBOTO;
            case 'HELVETICA':
                return idm_report_export_service_client_js_1.FontName.HELVETICA;
            case 'TAHOMA':
                return idm_report_export_service_client_js_1.FontName.TAHOMA;
            case 'GEORGIA':
                return idm_report_export_service_client_js_1.FontName.GEORGIA;
            case 'PALATINO':
                return idm_report_export_service_client_js_1.FontName.PALATINO;
            case 'MONACO':
                return idm_report_export_service_client_js_1.FontName.MONACO;
            default:
                throw new Error("Unknown font " + fontname);
        }
    };
    TextStyleConverter.convertJsonToTextStyleDto = function (styleJson) {
        var titleStyle = new idm_report_export_service_client_js_1.TextStyleDto();
        if (styleJson) {
            if (styleJson.fontName) {
                titleStyle.fontName = TextStyleConverter.convertStringToFontName(TextStyleConverter.isFontNameObject(styleJson.fontName) ?
                    styleJson.fontName.fontName : styleJson.fontName);
            }
            titleStyle.fontSize = styleJson.fontSize;
            titleStyle.color = styleJson.color;
            titleStyle.backgroundColor = styleJson.backgroundColor;
            titleStyle.isBold = styleJson.isBold;
            titleStyle.isUnderline = styleJson.isUnderline;
            titleStyle.isItalic = styleJson.isItalic;
            titleStyle.align = styleJson.align;
            titleStyle.width = styleJson.width;
        }
        return titleStyle;
    };
    /**
     * Check whether fontName is string property of object: {'fontName': ...} or just string
     */
    TextStyleConverter.isFontNameObject = function (font) {
        return font.hasOwnProperty('fontName');
    };
    return TextStyleConverter;
}());
exports.TextStyleConverter = TextStyleConverter;
//# sourceMappingURL=text-style-converter.js.map